module.exports = __webpack_public_path__ + "static/media/scissor.b0555114.svg";